"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bagnolo-in-piano": {
    "46b795a1": [{
      "hkey": "381d200e",
      "slug": "san-tomaso-della-fossa",
      "name": "San Tomaso della Fossa",
      "primary": true,
      "skipSearch": false
    }],
    "san-tommaso-della-fossa": [{
      "hkey": "381d200e",
      "slug": "san-tomaso-della-fossa",
      "name": "San Tomaso della Fossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;